<template>
    <o-form :title="$t('sandoz.customer')"
            :url="'/api/customers/' + $route.params.id + '?include=extension,contracts,external_ids,external_ids.customer_login,contracts.invoices,contracts.archive_invoices,external_ids.customer_login.login_history,external_ids.customer_login.login_history.user'"
            class="ortic-form-horizontal" ref="form">
        <template slot-scope="props">
            <div class="row">
                <div class="col">
                    <strong>{{props.item.external_id}}</strong><br><br>

                    {{props.item.full_name}}<br>
                    <template v-if="props.item.street">{{props.item.street}}<br></template>
                    <template v-if="props.item.zip_code || props.item.city">{{props.item.zip_code}} {{props.item.city}}<br></template>
                </div>
                <div class="col">
                    <strong>{{$t('sandoz.bank')}}</strong>
                    <br><br>

                    <template v-if="props.item.extension">
                        <template v-if="props.item.extension.iban || props.item.extension.bank_name || props.item.extension.bank_address || props.item.extension.bank_account || props.item.extension.bank_account_address">
                            <strong>{{$t('customer.non_educational_contracts')}}<br></strong>
                        </template>
                        <template v-if="props.item.extension.iban">{{props.item.extension.iban}}<br></template>
                        <template v-if="props.item.extension.bank_name || props.item.extension.bank_address">{{props.item.extension.bank_name}} / {{props.item.extension.bank_address}}<br></template>
                        <template v-if="props.item.extension.bank_account || props.item.extension.bank_account_address">{{props.item.extension.bank_account}} / {{props.item.extension.bank_account_address}}</template>
                        <template v-if="props.item.extension.vat">{{props.item.extension.vat}}</template>

                        <template v-if="checkEduContract(props.item.contracts) && (props.item.extension.iban_edu || props.item.extension.bank_name_edu || props.item.extension.bank_address_edu || props.item.extension.bank_account_edu || props.item.extension.bank_account_address_edu)">
                            <strong><br><br>{{$t('customer.educational_contracts')}}<br></strong>
                        </template>
                        <template v-if="props.item.extension.iban_edu">{{props.item.extension.iban_edu}}<br></template>
                        <template v-if="props.item.extension.bank_name_edu || props.item.extension.bank_address_edu">{{props.item.extension.bank_name_edu}} / {{props.item.extension.bank_address_edu}}<br></template>
                        <template v-if="props.item.extension.bank_account_edu || props.item.extension.bank_account_address_edu">{{props.item.extension.bank_account_edu}} / {{props.item.extension.bank_account_address_edu}}</template>
                    </template>
                </div>
                <div class="col">
                    <strong>{{$t('sandoz.users')}}</strong>
                    <br><br>

                    <template v-for="externalId in props.item.external_ids">
                        {{externalId.customer_login.email}}<br>
                    </template>
                </div>
            </div>
        </template>
        <template slot="child" slot-scope="props">
            <b-tabs>
                <b-tab :title="$t('sandoz.contracts')" active>
                    <o-card v-if="props.item.contracts && props.item.contracts.length" >
                        <b-card no-body class="mb-1" v-for="(contract, contractIndex) in props.item.contracts" :key="contract.id">
                            <b-card-header header-tag="header" class="p-0 mb-2" role="tab">
                                <b-button block v-b-toggle="'accordion' + contract.id" variant="primary">{{contract.contract_no}}</b-button>
                            </b-card-header>
                            <b-collapse :id="'accordion' + contract.id" :visible="contractIndex == props.item.contracts.length-1" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="no-shadow mb-2">
                                    <div class="row">
                                        <div class="col">
                                            <strong>{{$t('sandoz.contract')}}</strong>
                                        </div>
                                        <div class="col text-right">
                                            <b-btn variant="secondary" @click="download(contract)" v-if="canDownload (contract) && contract.status === 'Signed'">
                                                <fa icon="download"/>
                                            </b-btn>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            <o-form-group :label="$t('sandoz.responsible_sales_person')">
                                                <div class="form-control border-0">
                                                    {{ contract.responsible_sales_person }}
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.turnover')">
                                                <div class="form-control border-0">
                                                    {{ contract.turnover | formatNumber }}
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.turnover_expectation')">
                                                <div class="form-control border-0">
                                                    {{ contract.turnover_expectation | formatNumber }}
                                                </div>
                                            </o-form-group>
                                        </div>
                                        <div class="col">
                                            <o-form-group :label="$t('sandoz.invest_turnover_percentage')">
                                                <div class="form-control border-0">
                                                    {{ contract.invest_turnover_percentage |formatPercentage }}%
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.invest_growth')">
                                                <div class="form-control border-0">
                                                    {{ contract.invest_growth | formatPercentage }}%
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.growth_forecast')">
                                                <div class="form-control border-0">
                                                    {{ contract.growth_forecast | formatNumber }}
                                                </div>
                                            </o-form-group>
                                        </div>
                                        <div class="col">
                                            <o-form-group :label="$t('sandoz.services')">
                                                <div class="form-control border-0">
                                                    {{ contract.services | formatNumber }}
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.marketing_activities')">
                                                <div class="form-control border-0">
                                                    {{ contract.marketing_activities | formatNumber }}
                                                </div>
                                            </o-form-group>
                                            <o-form-group :label="$t('sandoz.marketing_activities_percentage')">
                                                <div class="form-control border-0">
                                                    {{ contract.marketing_activities_percentage | formatPercentage }}%
                                                </div>
                                            </o-form-group>
                                        </div>
                                    </div>

                                    <hr>


                                    <table class="table table-sm">
                                        <tr>
                                            <th>{{$t('sandoz.invoice')}}</th>
                                            <th>{{$t('sandoz.time_period')}}</th>
                                            <th>{{$t('sandoz.created_at')}}</th>
                                            <th></th>
                                        </tr>
                                            <template v-if="contract.invoices.length == 0 && contract.archive_invoices.length == 0">
                                                {{$t('sandoz.no_invoices')}}
                                            </template>
                                            <template v-else>
                                                <tr v-for="invoice in contract.invoices" :key="invoice.id">
                                                    <td>#{{invoice.id}}</td>
                                                    <td>{{invoice.start_month}} - {{invoice.end_month}}</td>
                                                    <td>{{invoice.created_at | formatDate}}</td>
                                                    <td class="text-right">
                                                        <b-btn variant="secondary" size="sm" @click="downloadInvoice(contract, invoice)">
                                                            <fa icon="download"/>
                                                        </b-btn>
                                                    </td>
                                                </tr>
                                                <tr v-for="archiveInvoice in contract.archive_invoices" :key="archiveInvoice.id">
                                                    <td>#ARCHIVE_{{archiveInvoice.id}}</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td class="text-right">
                                                        <b-btn variant="secondary" size="sm" @click="downloadArchiveInvoice(contract, archiveInvoice)">
                                                            <fa icon="download"/>
                                                        </b-btn>
                                                    </td>
                                                </tr>
                                            </template>
                                        </table>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </o-card>
                    <o-card v-else>
                        {{$t('sandoz.no_contract_access')}}
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.history')">
                    <o-card>
                        <div v-for="externalId in props.item.external_ids" :key="externalId.customer_login.email">
                            <strong>{{externalId.customer_login.email}}</strong>

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{$t('sandoz.user')}}</th>
                                        <th>{{$t('sandoz.date')}}</th>
                                        <th>{{$t('sandoz.invitation_email')}}</th>
                                        <th>{{ $t('sandoz.data') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(history, historyIndex) in externalId.customer_login.login_history" :key="historyIndex">
                                        <td>{{ history.user.name }}</td>
                                        <td>{{ history.created_at | formatDate }}</td>
                                        <td>{{ history.invitation_email ? $t('sandoz.yes') : $t('sandoz.no') }}</td>
                                        <td>
                                            <span @click="history.show_data = !history.show_data">...</span>
                                            <span v-if="history.show_data">{{ history.data }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
            </b-tabs>
        </template>
    </o-form>
</template>


<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
    data: () => ({
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    created () {

    },
    methods: {
        hasPermission(item) {
            let result = true
            let permissions = item
            let user = this.user
            if (!user.is_super_user && permissions) {
                permissions.forEach((permission) => {
                    if (!user.routePermissions.includes(permission)) {
                      result = false
                    }
                })
            }
            return result
        },
        canDownload (contract) {
            if (this.hasPermission(['GET api/contracts/{id}/pdf']) && contract) {
                if (contract.is_kam) {
                    return !!this.user.is_kam_user
                }
                return true
            }
            return false
        },
        download(contract) {
            axios.get('/api/contracts/' + contract.id + '/pdf', { responseType: 'arraybuffer' })
                .then((response) => {
                    require('downloadjs')(response.data,
                        contract.customer_external_id + '.pdf', 'application/pdf'
                    )
                }).catch((error) => {
                    if (error.response.status === 404) {
                        this.$notify({
                            title: this.$i18n.t('core.error'),
                            text: this.$i18n.t('sandoz.file_not_found'),
                            type: 'error'
                        })
                    } else {
                        this.$notify({
                          title: this.$i18n.t('core.error_alert_title'),
                          text: this.$i18n.t('core.error_alert_text'),
                          type: 'error'
                        })
                    }
            })
        },
        downloadArchiveInvoice(contract, archiveInvoice) {
            axios.get('/api/contracts/' + contract.id + '/archive-invoices/' + archiveInvoice.id + '/pdf', { responseType: 'arraybuffer' })
                .then((response) => {
                    require('downloadjs')(response.data,
                        'archive_invoice_' + archiveInvoice.id + '.pdf', 'application/pdf'
                    )
                }).catch((error) => {
                    if (error.response.status === 404) {
                        this.$notify({
                            title: this.$i18n.t('core.error'),
                            text: this.$i18n.t('sandoz.file_not_found'),
                            type: 'error'
                        })
                    } else {
                        this.$notify({
                          title: this.$i18n.t('core.error_alert_title'),
                          text: this.$i18n.t('core.error_alert_text'),
                          type: 'error'
                        })
                    }
            })
        },
        downloadInvoice(contract, invoice) {
            axios.get('/api/contracts/' + contract.id + '/invoices/' + invoice.id + '/pdf', { responseType: 'arraybuffer' })
                .then((response) => {
                    require('downloadjs')(response.data,
                        'invoice_' + invoice.id + '.pdf', 'application/pdf'
                    )
                }).catch((error) => {
                    if (error.response.status === 404) {
                        this.$notify({
                            title: this.$i18n.t('core.error'),
                            text: this.$i18n.t('sandoz.file_not_found'),
                            type: 'error'
                        })
                    } else {
                        this.$notify({
                          title: this.$i18n.t('core.error_alert_title'),
                          text: this.$i18n.t('core.error_alert_text'),
                          type: 'error'
                        })
                    }
            })
        },
        checkEduContract(contracts) {
            var eduContract = false
            contracts.forEach((contract, index) => {
                if (contract.type.endsWith("_EDU")) {
                    eduContract = true
                }
            });
            return eduContract
        }
    }
}
</script>

